import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { getOtpSession, verifyOtp } from "../api/core";
import "./login.css";
import Global from "../../global";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import InPlayer from "../backend/inplayer";
import { UserStore } from "../store/store";
import Cookies from "js-cookie";

const VerifyOtp = (props) => {
  const otp = useFormInput("");

  let history = useHistory();
  const [loading, setLoading] = useState(false);
  /* eslint-disable no-unused-vars */
  const [session, getSession] = useState(getOtpSession());
  //const [otpVal,setOTPVAl] =useState((Cookies.get('sm_ott_val')==="true")) ;
  /* eslint-disable no-unused-vars */
  const currentUser = UserStore.useState((s) => s.user);

  useEffect(() => {
    if (currentUser.PHONE_VERIFIED || !Global.OTP) {
      let path = "/" + props.match.params.AppId + "/home";

      history.push(path);
    }
    if (
      !currentUser.PHONE_VERIFIED &&
      Global.OTP &&
      (session === null || session === "undefined" || session === "")
    ) {
      let path = "/" + props.match.params.AppId + "/sendotp";

      history.push(path);
    }
  }, [history, currentUser.PHONE_VERIFIED, props.match.params.AppId, session]);
  function updateUser(s) {
    UserStore.update((s) => {
      s.user.PHONE_VERIFIED = true;
    });
  }

  const verify = async (event) => {
    setLoading(true);
    event.preventDefault();
    /* eslint-disable no-unused-vars */
    const result = await verifyOtp(Global.OTPKey, session, otp.value).then(
      (res) => {
        if (res.status === 200) {
          localStorage.removeItem("2f_session");
          if (
            res.data.Status === "Success" &&
            res.data.Details === "OTP Matched"
          ) {
            setLoading(false);
            Cookies.set("sm_ott_val", true, { expires: 2 });
            UserStore.update(updateUser);

            toastr.success(res.data.Details, "Success");
            if (Global.LOGIN && Global.SUBSCRIPTION) {
              InPlayer.Account.updateAccount({
                metadata: { phone_verifed: true },
              }).then((data) => {
                console.log();
              });

              let path = "/" + props.match.params.AppId + "/premium";

              history.push(path);
            } else if (Global.LOGIN && !Global.SUBSCRIPTION) {
              InPlayer.Account.updateAccount({
                metadata: { phone_verifed: true },
              }).then((data) => {
                console.log();
              });
              let path = "/" + props.match.params.AppId + "/home";

              history.push(path);
            } else if (!Global.LOGIN && Global.SUBSCRIPTION) {
              InPlayer.Account.updateAccount({
                metadata: { phone_verifed: true },
              }).then((data) => {
                console.log("");
              });
              let path = "/" + props.match.params.AppId + "/home";

              history.push(path);
            } else {
              console.log();
            }
          } else {
            setLoading(false);
            toastr.error(res.data.Details, "Error");
          }
        }
      },
      (err) => {
        setLoading(false);
        toastr.error("OTP Does not Match", "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };
  if (!loading && !currentUser.PHONE_VERIFIED) {
    return (
      <div>
        <section
          className="sign-in-page"
          style={{
            background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
          }}
        >
          <div className="container">
            <div className="row justify-content-center align-items-center height-self-center">
              <div className="col-lg-5 col-md-12 align-self-center">
                <div className="sign-user_card ">
                  <div className="sign-in-page-data">
                    <div className="sign-in-from w-100 m-auto">
                      <h3 className="mb-3 text-center">Verify OTP</h3>
                      <p className="mt-3">
                        An Otp has been sent to your registered number.Please
                        enter the OTP below
                      </p>
                      <form className="mt-4" onSubmit={verify}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control mb-0"
                            name="otp"
                            id="otp"
                            placeholder="Enter your OTP"
                            autoComplete="off"
                            required
                            {...otp}
                          />
                        </div>

                        <div className="sign-info">
                          <button
                            type="submit"
                            className="btn btn-hover"
                            style={{ float: "right" }}
                          >
                            Verify
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div style={{ paddingTop: "40px" }}></div>

                  <div style={{ paddingTop: "20px" }}></div>
                  <div className="mt-3">
                    <div className="d-flex justify-content-center links">
                      Didn't Receive OTP{" "}
                      <Link
                        to={"/" + props.match.params.AppId + "/register"}
                        className="text-primary ml-2"
                      >
                        {" "}
                        Resend OTP
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  } else {
    return <Loader load={"Default"}></Loader>;
  }
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
export default VerifyOtp;
